/**
 * Javascript for the review questions section
 */
import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/manipulation/text/text.js";

export default obj => {

	// insert pre-prepared statements into the current position box on click
	obj.on("click", function () {
		const $this = $(this),
			text = $("#" + $this.data("for")),
			val = text.val().trim(),
			start = text.prop("selectionStart");
		text.val((start ? val.substr(0, start) + " " : "") + $this.text() + val.substr(text.prop("selectionEnd")));
	});
};
